import React, { useCallback, useEffect, useRef, useState } from "react";
import useCurrencies from "../../hooks/useCurrencies";
import { COUNTRY_KS } from "../../api/currency";
import OrderDetailRow from "../../components/form/OrderDetailRow";
import CurrencySelectField from "../../components/form/CurrencySelectField";
import { Alert, Button, Divider, Modal, Radio, SelectProps } from "antd";
import api from "../../utils/axios";
import {
	PrinterOutlined,
	FormOutlined,
	DeleteOutlined,
	CheckOutlined,
	CameraOutlined,
} from "@ant-design/icons";
import OrderHistory from "../../components/OrderHistory";
import DefaultSelect from "../../components/form/DefaultSelect";
import { toast } from "react-toastify";
import "./OrderDetails.css";
import { useNavigate } from "react-router";
import Buttons from "../../components/form/Buttons";
import { getUserRoleFromToken } from "../../utils/Auth";
import { fetchAllUsers } from "../../lib/UserApi";
import useOnDemand from "../../hooks/useOnDemand";
import { useConfiguration } from "../../hooks/useConfiguration";
import { ConfigurationId } from "../../types/Lookups";
import { fetchZonesCached } from "../../lib/cachedLookups";
import { orderStatuses, userRoles } from "../../types/enums";
import useLang from "../../hooks/useLang";
import OrderPriceChangeRequest from "../../components/OrderPriceChangeRequest";
import SettlementOrderHistory from "../../components/SettlementOrderHistory";
import { hasAccess } from "../../lib/MenuValidation";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { CONFIG } from "../../config";
import { currencySymbol } from "../../utils/formatters";
import AddressSelect from "../../components/form/AddressSelect";
import DefaultInput from "../../components/form/DefaultInput";
import { MenuAccess } from "../../utils/menuOptions";
import { PagedResult } from "../../api/client-reports/types";

interface IOrderHistory {
	statusId: number;
	orderId: number;
	userId: number;
	statusDate: string;
	statusChangeComment?: string;
	userRoleDescription?: string;
	phone?: string;
	userName?: string;
}
interface Zone {
	id: number;
	description: string;
	levelId: number;
	parentId: any;
}
interface SortingMachinePhoto {
	objectKey: string;
	base64Data: string;
	sizeBytes: number;
	cameraId: number;
}
const statusOptions = [
	{ value: 3, label: "Grumbulluar" },
	{ value: 4, label: "Në depo" },
	{ value: 5, label: "Në transport" },
	{ value: 6, label: "Dorëzuar" },
	{ value: 7, label: "Refuzuar" },
	{ value: 8, label: "Në pritje" },
	{ value: 9, label: "Në pritje për tërheqje" },
	{ value: 10, label: "Kthyer" },
	//{ value: 11, label: "Ndërrim" },
	{ value: 13, label: "Ne Depon për kthim" },
	{ value: 14, label: "Ne Transport Internacional" },
];

const macedonianStatusTranslations: any = {
	3: "Собрано",
	4: "Во магацин",
	5: "Во транспорт",
	6: "Испорачано",
	7: "Одбиено",
	8: "Во очекување",
	9: "На чекање за повлекување",
	10: "Вратено",
	13: "Во магацин за враќање",
	14: "Во меѓународен транспорт",
};

const specialReturnedStatusOptions = [
	{ value: orderStatuses.IN_STORAGE, label: "Në depo" },
];

const nonEditableStatusIds = [
	orderStatuses.DELIVERED,
	orderStatuses.REJECTED,
	orderStatuses.AWAITING_WITHDRAWL,
	orderStatuses.RETURNED,
	orderStatuses.EXCHANGE,
	orderStatuses.REDIRECTED,
	orderStatuses.RETURN_STORAGE,
];

const nonEditableStatusIdsClient = [
	orderStatuses.PICKED_UP,
	orderStatuses.IN_STORAGE,
	orderStatuses.TRANSPORTING,
	orderStatuses.DELIVERED,
	orderStatuses.REJECTED,
	orderStatuses.PENDING,
	orderStatuses.AWAITING_WITHDRAWL,
	orderStatuses.RETURNED,
	orderStatuses.EXCHANGE,
	orderStatuses.REDIRECTED,
	orderStatuses.RETURN_STORAGE,
	orderStatuses.INTERNATIONAL_TRANSPORTING,
	orderStatuses.REFUNDED,
	orderStatuses.CANCELLED,
];

const statusAccessMap: Record<number, MenuAccess> = {
	3: "ORDER_STATUS_CHANGE_PICKED_IP_ACCESS",
	4: "ORDER_STATUS_CHANGE_IN_STORAGE_ACCESS",
	5: "ORDER_STATUS_CHANGE_TRANSPORTING_ACCESS",
	6: "ORDER_STATUS_CHANGE_DELIVERED_ACCESS",
	7: "ORDER_STATUS_CHANGE_REJECTED_ACCESS",
	8: "ORDER_STATUS_CHANGE_PENDING_ACCESS",
	9: "ORDER_STATUS_CHANGE_AWAITING_WITHDRAWL_ACCESS",
	10: "ORDER_STATUS_CHANGE_RETURNED_ACCESS",
	13: "ORDER_STATUS_CHANGE_RETURN_STORAGE_ACCESS",
	14: "ORDER_STATUS_CHANGE_INTL_TRANSPORTING_ACCESS",
};
const OrderDetails = () => {
	const [orderDetilsData, setOrderDetilsData] = useState<any>([]);
	const [openStatusChangeModal, setOpenStatusChangeModal] =
		useState<boolean>(false);
	const [open, setOpen] = useState<boolean>(false);
	const [
		openChangeStatusToPreviousModal,
		setOpenChangeStatusToPreviousModal,
	] = useState<boolean>(false);
	const [orderHistory, setOrderHistory] = useState<IOrderHistory[]>([]);
	const [settlementOrderHistory, setSettlementOrderHistory] = useState<
		IOrderHistory[]
	>([]);
	const [selectedStatus, setSelectedStatus] = useState<number | null>(null);
	const [selectedUser, setSelectedUser] = useState<number | null>(null);
	const [userOptions, setUserOptions] = useState<any>([]);
	const [isAdmin, setIsAdmin] = useState<boolean>(false);
	const [isClient, setIsClient] = useState<boolean>(false);
	const [userRole, setUserRole] = useState<any>();
	// Every user, for the status-change window only: loaded the first time it opens instead of
	// on every order opened.
	const { data: allUsers, load: loadAllUsers } = useOnDemand(fetchAllUsers);

	const [refId, setRefId] = useState<string>("");
	const [orderDescription, setOrderDescription] = useState<string>("");
	const [packageDescription, setPackageDescription] = useState<string>("");
	const [deliveryInstructions, setDeliveryInstructions] =
		useState<string>("");
	const [openable, setOpenable] = useState<boolean>(false);
	const [fragile, setFragile] = useState<boolean>(false);
	const [declared, setDeclared] = useState<boolean>(false);
	const [allowEdit, setAllowEdit] = useState<boolean>(false);
	const [allowEditTransportPrice, setAllowEditTransportPrice] =
		useState<boolean>(false);
	const [allowEditSellerDescription, setAllowEditSellerDescription] =
		useState<boolean>(false);
	const [warehouseManager, setWarehouseManager] = useState<boolean>();
	const [width, setWidth] = useState<string | null>();
	const [length, setLength] = useState<string | null>();
	const [height, setHeight] = useState<string | null>();
	const [weight, setWeight] = useState<string | null>();
	const [buyerFirstName, setBuyerFirstName] = useState<string | null>();
	const [buyerLastName, setBuyerLastName] = useState<string | null>();
	const [buyerPhoneNo, setBuyerPhoneNo] = useState<string>();
	const [initialBuyerPhoneNo, setInitialBuyerPhoneNo] = useState<string>();
	const [buyerAddress, setBuyerAddress] = useState<string | null>();
	const [buyerAddressDetails, setBuyerAddressDetails] = useState<
		string | null
	>();
	const [selectedCountry, setSelectedCountry] = useState<any>();
	const [selectedCity, setSelectedCity] = useState<any>();
	const [zones, setZones] = useState<Zone[]>([]);
	const [countryOptions, setCountryOptions] = useState<any>();
	const [cityOptions, setCityOptions] = useState<any>();
	const [countryLabel, setCountryLabel] = useState<string>("xk");
	const [cityLabel, setCityLabel] = useState<string | undefined>("");
	const [transportPrice, setTransportPrice] = useState<any>();
	const [orderPrice, setOderPrice] = useState<any>();
	const defaultSystemCountryId =
		useConfiguration(ConfigurationId.Country) ?? "";
	// System settings, read once per session. They used to be fetched again on every reload of
	// the order (after each save, status change or revert).
	const phonePrefix = useConfiguration(ConfigurationId.PhonePrefix) ?? "";
	const [allowOrderPriceEditing, setAllowOrderPriceEditing] =
		useState<boolean>(false);
	const [buyersList, setBuyersList] = useState<any[]>([]);
	const [isExistingPhoneNumberVisible, setIsExistingPhoneNumberVisible] =
		useState<boolean>(false);
	const { strings } = useLang("orderDetails");
	const { countryId, dualCurrencyEnabled, selectableCurrencies } =
		useCurrencies();

	/**
	 * The currency correction: which currency the staff member has picked, and whether a save is in
	 * flight. Seeded from the order once it loads (see getOrderDetails).
	 */
	const [editedOrderCurrencyId, setEditedOrderCurrencyId] = useState<
		number | undefined
	>(undefined);
	const [savingOrderCurrency, setSavingOrderCurrency] =
		useState<boolean>(false);
	/**
	 * The confirmation step. Added when the endpoint started RE-PRICING the order rather than only
	 * relabelling it: the button used to change a label, and now it changes what the seller is owed
	 * and what the buyer pays. That is not something to do on a single click from a screen whose
	 * other controls all save through a shared form.
	 */
	const [orderCurrencyConfirmOpen, setOrderCurrencyConfirmOpen] =
		useState<boolean>(false);

	/**
	 * The collected-currency correction. Same pair, for the currency the driver actually took at
	 * the door rather than the one the seller registered in.
	 */
	const [editedDeliveredCurrencyId, setEditedDeliveredCurrencyId] = useState<
		number | undefined
	>(undefined);
	const [savingDeliveredCurrency, setSavingDeliveredCurrency] =
		useState<boolean>(false);

	// const location = useLocation();
	// const orderId = location.state;
	const [lastValidWeight, setLastValidWeight] = useState<string | null>(null);
	const [lastValidHeight, setLastValidHeight] = useState<string | null>(null);
	const [lastValidLength, setLastValidLength] = useState<string | null>(null);
	const [lastValidWidth, setLastValidWidth] = useState<string | null>(null);
	const [lastValidOrderPrice, setLastValidOrderPrice] = useState<
		string | null
	>(null);
	const [lastValidTransportPrice, setLastValidTransportPrice] = useState<
		string | null
	>(null);
	const [apiLatitude, setApiLatitude] = useState<number | null>();
	const [apiLongitude, setApiLongitude] = useState<number | null>();
	const [sectionId, setSectionId] = useState<number | null>(0);
	const [sellerDescription, setSellerDescription] = useState<string | null>(
		""
	);
	const [isPrintModalOpen, setIsPrintModalOpen] = useState(false);
	const [selectedFormat, setSelectedFormat] = useState("100x60");
	const [transportPriceChangeComment, setTransportPriceChangeComment] =
		useState<string>("");
	const [openTransportPriceCommentModal, setOpenTransportPriceCommentModal] =
		useState<boolean>(false);
	const [deliveryCode, setDeliveryCode] = useState<string>("");
	const [requiresDeliveryCode, setRequiresDeliveryCode] =
		useState<boolean>(false);
	const [sortingMachinePhotos, setSortingMachinePhotos] = useState<
		SortingMachinePhoto[]
	>([]);
	const [isSortingMachineModalOpen, setIsSortingMachineModalOpen] =
		useState<boolean>(false);
	const [isLoadingSortingMachinePhotos, setIsLoadingSortingMachinePhotos] =
		useState<boolean>(false);
	const urlParams = new URLSearchParams(window.location.search);
	const orderId = urlParams.get("id");

	const navigate = useNavigate();

	const canUpdateDetails = hasAccess("UPDATE_ORDER_DETAILS_ACCESS");
	const canUpdateOrderDimensions = hasAccess("UPDATE_ORDER_DIMENSION_ACCESS");
	const canChangeOrderValue = hasAccess("ORDER_VALUE_CHANGE_ACCESS");
	const canChangeOrderCurrency = hasAccess("ORDER_CURRENCY_CHANGE_ACCESS");
	const canChangeDeliveredCurrency = hasAccess(
		"DELIVERED_CURRENCY_CHANGE_ACCESS"
	);
	const canChangeOrderStatus = hasAccess("ORDER_STATUS_CHANGE_ACCESS");
	const canChangeRefuseOrAwaitOrderStatus = hasAccess(
		"ORDER_AWAIT_OR_REFUSAL_STATUS_CHANGE_ACCESS"
	);
	const hasAccessToA4 = hasAccess("A4_TICKETS_ACCESS");
	const hasAccessToHarleyTickets = hasAccess("HARLEY_TICKETS_ACCESS");
	const hasAccessToSellers = hasAccess("ORDER_DETAILS_SELLER_ACCESS");
	const hasAccessToDeliveryCode = hasAccess("DELIVERY_CODE_ACCESS");
	const hasAccessToIdentificationNo = hasAccess("IDENTIFICATION_NO_ACCESS");
	const accessToOrderPrice = hasAccess("ORDER_DETAILS_ORDER_PRICE_ACCESS");
	const accessToOrderTransportPrice = hasAccess(
		"ORDER_DETAILS_ORDER_TRANSPORT_PRICE_ACCESS"
	);
	const accessToOrderRealPrice = hasAccess(
		"ORDER_DETAILS_ORDER_REAL_PRICE_ACCESS"
	);
	const accessToOrderRealSeller = hasAccess(
		"ORDER_DETAILS_ORDER_REAL_SELLER_ACCESS"
	);
	const accessToSaleProfit = hasAccess("ORDER_DETAILS_SALE_PROFIT_ACCESS");
	const accessToSettlementHistory = hasAccess(
		"ORDER_DETAILS_SETTLEMENT_ACCESS"
	);
	const accessToOrderDimensions = hasAccess(
		"ORDER_DETAILS_DIMENSIONS_ACCESS"
	);
	const noAccessToInternationalOrderPrice = hasAccess(
		"HIDE_INTERNATIONAL_ORDERS_PRICE_ACCESS"
	);
	const hasReturnedToStorageAccess = hasAccess(
		"ORDER_STATUS_CHANGE_RETURNED_TO_STORAGE_ACCESS"
	);

	var sellersWithInternationalOrderPrice = [1, 2, 3];

	const currentLang = useSelector(
		(state: RootState) => state.langReducer.lang
	);

	const isInternationalOrder =
		(orderDetilsData?.countryId !== undefined &&
			defaultSystemCountryId !== "" &&
			orderDetilsData?.countryId !== parseInt(defaultSystemCountryId)) ||
		(orderDetilsData?.internationalStatusId !== null &&
			orderDetilsData?.internationalStatusId !== undefined &&
			orderDetilsData?.internationalStatusId !== 0);

	const canReopenReturnedOrderToStorage =
		hasReturnedToStorageAccess &&
		orderDetilsData?.statusId === orderStatuses.RETURNED &&
		!isInternationalOrder;

	/**
	 * Whether the registration currency is past changing.
	 *
	 * The window closes at delivery: from that moment the buyer has handed over cash in a specific
	 * currency and the driver owes exactly that, so re-denominating the order would move the
	 * seller's credit to the other balance while the driver's debt stayed put — and nothing in this
	 * system converts between the two.
	 *
	 * The three closure flags come after it and are included because they are the same signals this
	 * screen already uses to declare the order closed for changes. The API enforces its own version
	 * of this (StatusId = 6, or any OrderPayment row); this is the screen telling the truth up front
	 * rather than letting a save fail.
	 */
	/**
	 * An international order's registration currency is frozen, in either direction, whatever that
	 * currency is — it keeps what it was registered with. Not "must be EUR": a LEK order bound for
	 * Kosovo stays LEK.
	 *
	 * Origin against DESTINATION, deliberately, rather than either against the deployment country.
	 * `defaultSystemCountryId` is a string from a separate fetch while `useCurrencies().countryId`
	 * is a number, and this comparison needs neither. It is also the test the order-history block
	 * further down this file already uses.
	 */
	const orderCurrencyInternational =
		orderDetilsData?.originCountryId !== undefined &&
		orderDetilsData?.countryId !== undefined &&
		orderDetilsData?.originCountryId !== orderDetilsData?.countryId;

	const orderCurrencyLocked =
		orderCurrencyInternational ||
		orderDetilsData?.statusId === orderStatuses.DELIVERED ||
		orderDetilsData?.completed === 1 ||
		orderDetilsData?.settlementStatus > 0 ||
		orderDetilsData?.hasDriverSettlement === true;

	/**
	 * Whether the save button is inert — locked order, nothing picked, or the picked currency is
	 * the one the order already has.
	 *
	 * Hoisted out of the JSX because it is now read three times: by the button's `disabled`, by the
	 * styling that must not paint a brand background under a disabled label, and by the confirm
	 * dialog's guard. Inlining it three times is how the second and third copies drift.
	 */
	const orderCurrencySaveDisabled =
		orderCurrencyLocked ||
		!editedOrderCurrencyId ||
		editedOrderCurrencyId === orderDetilsData?.orderCurrencyId;

	/**
	 * The brand fill for the save button — and the bug fix.
	 *
	 * The button carried `style={{ backgroundColor: "#4F16C2" }}` and nothing else. An inline style
	 * beats every stylesheet, antd's `:disabled` rule included, so the fill survived into the
	 * disabled state while the label dropped to the disabled foreground, `rgba(0,0,0,0.25)`. That
	 * is near-black on dark purple — 1.4:1, which is the black label staff reported — and it was
	 * the FIRST thing they saw, because the button starts disabled: the picker is seeded with the
	 * currency the order already has, so nothing is changed until they touch it.
	 *
	 * Two fixes, both needed:
	 *   · `color` is set alongside `backgroundColor`, which is what every other brand-filled button
	 *     on this screen already does (the print-ticket button, ~line 1590). White on #4F16C2 is
	 *     9.2:1.
	 *   · nothing is painted at all when the button is disabled, so antd's own disabled styling
	 *     comes through — grey on grey, the same affordance as every other disabled control in the
	 *     app, rather than a button that looks live and is not.
	 *
	 * The loading state needs no third case: antd does not mark a loading button `:disabled`, it
	 * fades the whole element with `opacity: .65`, so the white label fades with its own background
	 * and stays legible.
	 *
	 * Hoisted because the same button appears twice — in the panel and as the confirm dialog's OK.
	 */
	const orderCurrencySaveButtonStyle = orderCurrencySaveDisabled
		? undefined
		: { backgroundColor: "#4F16C2", color: "#ffffff" };

	/**
	 * Whether the collected currency is changeable — the near-inverse of the window above.
	 *
	 * It OPENS at delivery, because until then no cash has changed hands and there is no payment
	 * row to correct, and it CLOSES when the driver is settled, because from that moment the money
	 * sits in a cash register denominated in a specific currency and re-labelling it would leave
	 * that register no longer reconciling.
	 *
	 * Deliberately NOT gated on `completed` or `settlementStatus`. Those are the CLIENT's
	 * settlement, and the client is settled in the currency the order was REGISTERED in, never the
	 * collected one — so a client-settled order whose driver is still unsettled is genuinely still
	 * correctable. The API agrees; it checks delivery and driver settlement and nothing else.
	 */
	const deliveredCurrencyNotDelivered =
		orderDetilsData?.statusId !== orderStatuses.DELIVERED;
	const deliveredCurrencyLocked =
		deliveredCurrencyNotDelivered ||
		orderDetilsData?.hasDriverSettlement === true;

	/**
	 * Same treatment as the registration button above, and for the same reason: paint nothing when
	 * the control is inert, so antd's own disabled styling shows through instead of a brand fill
	 * sitting under a near-black label.
	 */
	const deliveredCurrencySaveDisabled =
		deliveredCurrencyLocked ||
		!editedDeliveredCurrencyId ||
		editedDeliveredCurrencyId === orderDetilsData?.deliveredCurrencyId;

	const deliveredCurrencySaveButtonStyle = deliveredCurrencySaveDisabled
		? undefined
		: { backgroundColor: "#4F16C2", color: "#ffffff" };

	const allowedStatusOptions = (
		canReopenReturnedOrderToStorage
			? specialReturnedStatusOptions
			: statusOptions
	).filter((opt) =>
		canReopenReturnedOrderToStorage
			? specialReturnedStatusOptions.some(
					(specialOption) => specialOption.value === opt.value
			  )
			: hasAccess(statusAccessMap[opt.value])
	);

	const translatedStatusOptions = allowedStatusOptions.map((option) => ({
		value: option.value,
		label:
			currentLang === "mk"
				? macedonianStatusTranslations[option.value] || option.label
				: option.label,
	}));

	const setOrderDetails = (data: any) => {
		setRefId(data?.refId);
		setOrderDescription(data?.orderDescription);
		setPackageDescription(data?.packageDescription);
		setDeliveryInstructions(data?.deliveryInstructions);
		setOpenable(data?.openable);
		setFragile(data?.fragile);
		setDeclared(data?.declared);
		setWidth(data?.width);
		setLength(data?.length);
		setHeight(data?.height);
		setLastValidHeight(data?.height);
		setLastValidLength(data?.length);
		setLastValidWidth(data?.width);
		setLastValidOrderPrice(data?.orderPrice);
		setLastValidTransportPrice(data?.transportPrice);
		setWeight(data?.weight);
		setLastValidWeight(data?.weight);
		setBuyerFirstName(data?.buyerFirstName);
		setBuyerLastName(data?.buyerLastName);
		setBuyerPhoneNo(data?.buyerPhoneNo);
		setInitialBuyerPhoneNo(data?.buyerPhoneNo);
		setBuyerAddressDetails(data?.buyerAddressDetails);
		setSelectedCountry(data?.countryId);
		setSelectedCity(data?.cityId);
		setTransportPrice(data.transportPrice);
		const ordersPriceWithCheck =
			noAccessToInternationalOrderPrice &&
			sellersWithInternationalOrderPrice.includes(data?.sellerId)
				? 0.0
				: data?.orderPrice;
		console.log(
			ordersPriceWithCheck,
			data?.orderPrice,
			"ordersPriceWithCheck"
		);
		// setOderPrice(data.orderPrice);
		setOderPrice(ordersPriceWithCheck);
		setSellerDescription(data.sellerDescription);
		setSectionId(data?.sectionId);
		setRequiresDeliveryCode(data.requiresDeliveryCode);
		if (data?.countryId === 1) {
			setCountryLabel("xk");
		} else if (data?.countryId === 2) {
			setCountryLabel("al");
		} else if (data?.countryId === 3) {
			setCountryLabel("mk");
		}
		let allowEditLocal = false;
		const userRole = getUserRoleFromToken();
		nonEditableStatusIds.includes(data.statusId) ||
		nonEditableStatusIds.includes(data.internationalStatusId) ||
		data.completed === 1 ||
		data.settlementStatus > 0 ||
		!canUpdateDetails
			? (allowEditLocal = false)
			: (allowEditLocal = true);

		if (userRole === userRoles.CLIENT || userRole === userRoles.SUBCLIENT) {
			if (
				nonEditableStatusIdsClient.includes(data.statusId) ||
				data.completed === 1 ||
				data.settlementStatus > 0
			) {
				allowEditLocal = false;
			} else {
				allowEditLocal = true;
			}
		}
		if (userRole !== userRoles.CLIENT && userRole !== userRoles.SUBCLIENT) {
			data.completed === 1 ||
			data.settlementStatus > 0 ||
			nonEditableStatusIds.includes(data.statusId) ||
			!canUpdateDetails
				? setAllowEditSellerDescription(false)
				: setAllowEditSellerDescription(true);
		}
		setAllowEdit(allowEditLocal);
		data.completed === 1 || data.settlementStatus > 0
			? setAllowEditTransportPrice(false)
			: setAllowEditTransportPrice(true);
		let allowedSellers: number[] = [];
		// Kosovo-only seller allow-list.
		//
		// This used to test `CONFIG?.CURRENCY === "€"` — a PERMISSION check keyed on a display
		// symbol. It was already unreliable (Albania shipped the same "€" config and so took the
		// Kosovo branch), and dual currency breaks it outright: the symbol is no longer a
		// per-deployment constant. countryId comes straight from the API and says what was
		// actually meant.
		if (countryId === COUNTRY_KS)
			allowedSellers = [
				591, 593, 596, 1312, 346, 7395, 7388, 7385, 7384, 7383, 183,
				8276, 10814, 10812, 10811, 10808, 10809,
			];

		/*Kerkes e albinit me i leju qeto sellers*/
		data?.statusId === orderStatuses.REGISTERED &&
		!data?.returnable &&
		allowedSellers.includes(data?.sellerId)
			? setAllowOrderPriceEditing(true)
			: setAllowOrderPriceEditing(false);
		setBuyerAddress(data?.buyerAddress);
		// if (autocompleteRef?.current) {
		// 	(autocompleteRef as any).current.setInputText(
		// 		data?.buyerAddress ? data.buyerAddress : ""
		// 	);
		// }
	};

	const getOrderHistory = async () => {
		try {
			const response = await api.get("Order/web-orderHistory", {
				params: {
					orderId: orderId, //!todo fix so that orderid is just 1 and doesnt need to call getorderidbystring
				},
			});
			setOrderHistory(response.data);
		} catch (error) {
			console.log("Error:", error);
		}
	};
	const getSettlementOrderHistory = async () => {
		try {
			const response = await api.get("Order/settlement-orderHistory", {
				params: {
					orderId: orderId,
				},
			});
			setSettlementOrderHistory(response.data);
		} catch (error) {
			console.log("Error:", error);
		}
	};

	const getDeliveryCode = async () => {
		try {
			const response = await api.get(
				"DeliveryCode/select-delivery-code-for-order",
				{
					params: {
						orderId: orderId,
					},
				}
			);
			setDeliveryCode(response.data);
		} catch (error) {
			console.log("Error:", error);
		}
	};

	const getOrderDetails = useCallback(async () => {
		try {
			const response = await api.get("Order/orderdetails", {
				params: {
					id: orderId,
				},
			});
			if (response.status === 200) {
				const data = response.data;
				setOrderDetails(data);
				setOrderDetilsData(data);
				// Re-seeded on every fetch, so a save that the API refused leaves the picker
				// showing what the order actually is rather than what was attempted.
				setEditedOrderCurrencyId(data?.orderCurrencyId);
				setEditedDeliveredCurrencyId(data?.deliveredCurrencyId);
			}
		} catch (error) {
			console.error("Error fetching order:", error);
		}
	}, [orderId]);

	/**
	 * Correct the currency the order was registered in.
	 *
	 * Its own endpoint, not part of the details save: the currency also re-freezes the order's
	 * exchange rate, re-prices its transport cost from the other currency's tariff bands and
	 * CONVERTS the order value, all in one transaction the API owns.
	 *
	 * The conversion is the API's, not this screen's, and deliberately so. It runs at the rate
	 * FROZEN ON THE ORDER, which is not the rate `useCurrencies().convert` knows — that one is the
	 * live mid rate off the currency list. Any figure previewed here would therefore be a different
	 * number from the one about to be written, which is worse than showing none: the confirmation
	 * below says what will happen and the refetch afterwards says what did.
	 */
	const saveOrderCurrency = async () => {
		if (!editedOrderCurrencyId || !orderDetilsData?.id) return;

		setOrderCurrencyConfirmOpen(false);
		setSavingOrderCurrency(true);
		try {
			const response = await api.patch("Order/order-currency", {
				orderId: orderDetilsData.id,
				orderCurrencyId: editedOrderCurrencyId,
			});
			if (response.status === 200) {
				// The new value comes back on the response, so the toast can state the figure the
				// order now carries instead of asking the operator to go and look. `orderPrice` is
				// nullable — an API predating the conversion returns nothing here — so the plain
				// message is kept as the fallback rather than printing "undefined".
				const newOrderPrice = response.data?.orderPrice;
				const changedMessage =
					strings?.orderCurrency?.saveSuccess ??
					"Monedha e porosisë u ndryshua";

				toast.success(
					newOrderPrice !== null && newOrderPrice !== undefined
						? `${changedMessage} — ${
								strings?.orderCurrency?.newValueLabel ??
								"vlera e re"
						  }: ${newOrderPrice}${currencySymbol(
								editedOrderCurrencyId
						  )}`
						: changedMessage
				);
				// The order value and the transport price both moved with the currency, so the
				// whole row is refetched rather than patched in place — the details rows, the
				// currency symbol beside every amount and the picker all re-seed from it.
				await getOrderDetails();
			}
		} catch (error: any) {
			// The API refuses with a reason — delivered, wrong destination, no tariff — and each
			// one is already an Albanian sentence. Showing it beats a generic failure toast.
			toast.error(
				error?.response?.data?.message ??
					strings?.orderCurrency?.saveError ??
					"Monedha e porosisë nuk u ndryshua"
			);
			// Put the picker back on the truth.
			setEditedOrderCurrencyId(orderDetilsData?.orderCurrencyId);
		} finally {
			setSavingOrderCurrency(false);
		}
	};

	/**
	 * Correct the currency the driver was recorded as having collected.
	 *
	 * Its own endpoint and its own permission, like the one above. Nothing is converted and no
	 * price moves: this only restates which currency the cash was, so the driver's register and
	 * their settlement bucket it correctly.
	 */
	const saveDeliveredCurrency = async () => {
		if (!editedDeliveredCurrencyId || !orderDetilsData?.id) return;

		setSavingDeliveredCurrency(true);
		try {
			const response = await api.patch("Order/delivered-currency", {
				orderId: orderDetilsData.id,
				deliveredCurrencyId: editedDeliveredCurrencyId,
			});
			if (response.status === 200) {
				toast.success(
					strings?.deliveredCurrency?.saveSuccess ??
						"Monedha e arkëtimit u ndryshua"
				);
				await getOrderDetails();
			}
		} catch (error: any) {
			// The API refuses with an Albanian sentence naming which edge of the window was hit.
			toast.error(
				error?.response?.data?.message ??
					strings?.deliveredCurrency?.saveError ??
					"Monedha e arkëtimit nuk u ndryshua"
			);
			setEditedDeliveredCurrencyId(orderDetilsData?.deliveredCurrencyId);
		} finally {
			setSavingDeliveredCurrency(false);
		}
	};

	const filterAndMapUsers = (users: any) => {
		return users
			?.filter((item: any) => item.userRoleId !== userRoles.CLIENT)
			.map((item: any) => ({
				value: item.id,
				label: `${item.firstName} ${item.lastName} - ${item.userRoleDescription}`,
			}));
	};

	const openStatusChangeWindow = async () => {
		const alreadyLoaded = allUsers !== undefined;
		const users = await loadAllUsers();
		// Until a status is picked the window offers every non-client user, as before.
		if (!alreadyLoaded && users) setUserOptions(filterAndMapUsers(users));
		setOpenStatusChangeModal(true);
	};

	const orderStatusChangeToPreviousStatus = async () => {
		var orderIds = [
			{
				id: String(await getOrderIdFromString(orderId)),
			},
		];
		try {
			const response = await api.post(
				"Order/change-to-previous-status",
				orderIds
			);
			if (response.status === 200) {
				await getOrderDetails();
				await getOrderHistory();
				await getSettlementOrderHistory();
				setOpenChangeStatusToPreviousModal(false);
				toast.success("Statusi u ndryshua me sukses");
			}
		} catch (error) {
			console.log(error);
		}
	};

	const [isUpdatingStatus, setIsUpdatingStatus] = useState(false);

	const orderStatusChange = async () => {
		setOnStatusChangeDisabled(true);
		let notAllowedStatusChangesForInternationalOrders = [
			orderStatuses.TRANSPORTING,
			orderStatuses.DELIVERED,
			orderStatuses.REJECTED,
			orderStatuses.PENDING,
			orderStatuses.AWAITING_WITHDRAWL,
			orderStatuses.RETURNED,
			orderStatuses.REDIRECTED,
			orderStatuses.RETURN_STORAGE,
		];
		let notAllowedStatusChangesForReturnOrders = [
			orderStatuses.AWAITING_WITHDRAWL,
			orderStatuses.REJECTED,
			orderStatuses.RETURNED,
			orderStatuses.RETURN_STORAGE,
			//orderStatuses.INTERNATIONAL_TRANSPORTING,
			orderStatuses.REDIRECTED,
		];
		const showError = (message: string) => {
			toast.error(message);
			setOnStatusChangeDisabled(false);
			return false;
		};
		if (
			(userRole === userRoles.SUPPORT ||
				userRole === userRoles.REGIONALMANAGER) &&
			orderDetilsData?.statusId === orderStatuses.DELIVERED
		) {
			return showError(
				"Nuk keni akses per te larguar porosine nga dorezimi!"
			);
		}

		// Check if the order is a return order and if the status change is allowed
		if (orderDetilsData?.returnable) {
			if (selectedStatus === orderStatuses.RETURNED) {
				if (
					userRole !== userRoles.MANAGER &&
					userRole !== userRoles.SUPPORT &&
					userRole !== userRoles.ADMIN
				) {
					return showError(
						"Kjo porosi eshte kthim i parave, dhe nuk mund te ndryshohet statusi ne 'Kthyer'!"
					);
				}
			} else if (
				selectedStatus !== null &&
				notAllowedStatusChangesForReturnOrders.includes(selectedStatus)
			) {
				return showError(
					"Kjo porosi eshte kthim i parave, dhe vetem statusi 'Kthyer' lejohet te ndryshohet nga menaxheri ose supporti!"
				);
			}

			if (orderDetilsData.statusId === orderStatuses.DELIVERED) {
				return showError(
					"Kjo porosi eshte kthim i pageses qe eshte dorezuar, nuk mund te ia ndryshoni statusin"
				);
			}
		}

		// Check if the order is international and if the status change is allowed
		if (
			orderDetilsData?.countryId !== parseInt(defaultSystemCountryId) &&
			selectedStatus !== null &&
			notAllowedStatusChangesForInternationalOrders.includes(
				selectedStatus
			)
		) {
			return showError(
				"Kjo porosi eshte internacionale dhe nuk mund te ia ndryshoni statusin"
			);
		}

		// Check if the international order has the correct status for further steps
		if (
			orderDetilsData?.internationalStatusId !== null &&
			orderDetilsData?.statusId === orderStatuses.REGISTERED
		) {
			if (
				orderDetilsData?.internationalStatusId !==
				orderStatuses.INTERNATIONAL_TRANSPORTING
			) {
				toast.error(
					`Kjo Porosi eshte internacionale dhe nuk eshte ende ${"Në Tranzit"} per tek ju!`
				);
				setOnStatusChangeDisabled(false);
				return;
			}

			if (
				selectedStatus !== null &&
				orderDetilsData?.internationalStatusId ===
					orderStatuses.INTERNATIONAL_TRANSPORTING &&
				selectedStatus !== orderStatuses.IN_STORAGE
			) {
				return showError(
					"Porosia eshte internacionale dhe duhet te pranohet ne depo para se te vazhdoje me hapa te tjere!"
				);
			}
		}

		if (
			orderDetilsData?.internationalStatusId !== null &&
			orderDetilsData?.internationalStatusId ===
				orderStatuses.INTERNATIONAL_TRANSPORTING &&
			selectedStatus !== null &&
			selectedStatus === orderStatuses.PICKED_UP
		) {
			toast.error(
				"Kjo porosi eshte internacionale dhe nuk mund te grumbullohet!"
			);
			setOnStatusChangeDisabled(false);
			return;
		}

		if (
			orderDetilsData?.completed === 1 ||
			orderDetilsData?.settlementStatus > 0
		) {
			toast.error(
				"Kjo porosi eshte e procesuar ne nje barazim, nuk mund te ia ndryshoni statusin"
			);
			setOnStatusChangeDisabled(false);
			return;
		}
		if (orderDetilsData?.statusId === orderStatuses.RETURNED) {
			if (!canReopenReturnedOrderToStorage) {
				toast.error(
					"Nuk mund te ndryshoni statusin e porosisë së kthyer."
				);
				setOnStatusChangeDisabled(false);
				return;
			}
			if (
				selectedStatus === null ||
				orderStatuses.IN_STORAGE !== selectedStatus
				// ![
				// 	orderStatuses.IN_STORAGE,
				// 	orderStatuses.RETURN_STORAGE,
				// ].includes(selectedStatus)
			) {
				toast.error(
					"Porosia e kthyer mund të ndryshohet vetëm në 'Në depo' ose 'Në depon për kthim'."
				);
				setOnStatusChangeDisabled(false);
				return;
			}
		}
		if (
			(selectedStatus === 7 || selectedStatus === 8) &&
			canChangeRefuseOrAwaitOrderStatus
		) {
			const orderParams = {
				orderId: await getOrderIdFromString(orderId),
				statusId: selectedStatus,
				statusChangeComment:
					selectedStatus === 7
						? "Porosia u refuzua nga"
						: "Porosia u vendos ne pritje nga",
				assignFromToUserId: selectedUser,
				transportPrice: orderDetilsData?.transportPrice,
				sellerId: orderDetilsData?.sellerId,
				countryId: orderDetilsData?.countryId,
				displayId: orderDetilsData?.displayId,
				originCountryId: orderDetilsData?.originCountryId,
				uuid: orderDetilsData?.uuid,
				isChatBotOrders: orderDetilsData?.isChatBotOrder,
			};
			try {
				setIsUpdatingStatus(true);
				const response = await api.post(
					"Order/admin-order-await-or-refusal",
					orderParams
				);
				if (response.status === 200) {
					await getOrderHistory();
					await getSettlementOrderHistory();
					statusChangeModalStateClean();
					toast.success("Statusi i porosise u ndryshua me sukses");

					return;
				}
				setOpen(false);
			} catch (error) {
				console.log(error);
			} finally {
				setIsUpdatingStatus(false);
				setOnStatusChangeDisabled(false);
			}

			return;
		}
		const orderParams = {
			orderId: await getOrderIdFromString(orderId),
			statusId: selectedStatus,
			userIdAssign: selectedUser,
			statusChangeComment: "Status Changed from ",
			exchangeable: orderDetilsData?.exchangeable,
			returnable: orderDetilsData?.returnable,
			invoice: orderDetilsData?.invoice,
			orderPrice: orderDetilsData?.orderPrice,
			transportPrice: orderDetilsData?.transportPrice,
			driverPrice: orderDetilsData?.driverPrice,
			countryId: orderDetilsData?.countryId,
			uuid: orderDetilsData?.uuid,
			originCountryId: orderDetilsData?.originCountryId,
			sellerId: orderDetilsData.sellerId,
			displayId: orderDetilsData?.displayId,
		};
		const orderDetailId = [
			{ orderId: await getOrderIdFromString(orderId) },
		];
		try {
			setIsUpdatingStatus(false);
			if (canChangeOrderStatus) {
				const response = await api.put(
					"Order/orderstatuschange",
					orderParams
				);
				if (response.status === 200) {
					await getOrderDetails();
					statusChangeModalStateClean();
					toast.success("Statusi i porosise u ndryshua me sukses!");
				}
			} else if (isClient) {
				const response = await api.post(
					"Order/clientorderstatusupdate",
					orderDetailId
				);
				if (response.status === 200) {
					await getOrderDetails();
					await getDeliveryCode();
					await getOrderHistory();
					await getSettlementOrderHistory();
					setOpen(false);
					toast.success("Statusi i porosise u ndryshua me sukses!");
				}
			} else {
				toast.error("Nuk mund te ndryshoni statusin e porosise");
				return;
			}
			setOpenStatusChangeModal(false);
			await getOrderHistory();
			await getSettlementOrderHistory();
		} catch (error) {
			console.log(error);
			toast.error("Error: " + error);
		} finally {
			setIsUpdatingStatus(false);
			setOnStatusChangeDisabled(false);
		}
	};

	const statusChangeModalStateClean = () => {
		setSelectedStatus(null);
		setSelectedUser(null);
		setOpenStatusChangeModal(false);
	};

	useEffect(() => {
		const userRoleId = getUserRoleFromToken();
		setUserRole(userRoleId);
		userRoleId === userRoles.ADMIN ? setIsAdmin(true) : setIsAdmin(false);
		userRoleId === userRoles.CLIENT || userRoleId === userRoles.SUBCLIENT
			? setIsClient(true)
			: setIsClient(false);
		userRoleId === userRoles.WAREHOUSEMANAGER
			? setWarehouseManager(true)
			: setWarehouseManager(false);
		if (!orderId) {
			navigate("/");
			return;
		}
		const fetchOrderHistory = async () => {
			try {
				const response = await api.get("Order/web-orderHistory", {
					params: {
						orderId: orderId,
					},
				});
				setOrderHistory(response.data);
			} catch (error) {
				console.log("Error:", error);
			}
		};
		getOrderDetails();
		fetchOrderHistory();
		getZones();
		getSettlementOrderHistory();
		getDeliveryCode();
	}, [orderId]);

	const [onStatusChangeDisabled, setOnStatusChangeDisabled] =
		useState<boolean>(false);

	const onStatusChange = (value: number) => {
		setSelectedStatus(value);
		setSelectedUser(null);
		const roleMapping: { [key: number]: number[] } = {
			[orderStatuses.TRANSPORTING]: [
				userRoles.DRIVER,
				userRoles.SUPERDRIVER,
			],
			[orderStatuses.DELIVERED]: [
				userRoles.DRIVER,
				userRoles.SUPERDRIVER,
			],
			[orderStatuses.REJECTED]: [userRoles.DRIVER, userRoles.SUPERDRIVER],
			[orderStatuses.PENDING]: [userRoles.DRIVER, userRoles.SUPERDRIVER],
			[orderStatuses.PICKED_UP]: [
				userRoles.COLLECTOR,
				userRoles.SUPERDRIVER,
			],
			[orderStatuses.IN_STORAGE]: [
				userRoles.WAREHOUSEMANAGER,
				userRoles.WAREHOUSE,
			],
			[orderStatuses.INTERNATIONAL_TRANSPORTING]: [
				userRoles.INTERNATIONAL_DRIVER,
			],
		};
		const matchingRoles = Object.keys(roleMapping).find(
			(status) => parseInt(status) === value
		);

		if (matchingRoles) {
			const roles = roleMapping[value];
			const filteredUsers = (allUsers ?? [])
				.filter((item: any) => roles.includes(item.userRoleId))
				.map((item: any) => ({
					value: item.id,
					label: `${item.firstName} ${item.lastName} - ${item.userRoleDescription}`,
				}));
			setUserOptions(filteredUsers);
		} else {
			const users = (allUsers ?? [])
				.filter(
					(item: any) =>
						item.userRoleId !== userRoles.CLIENT &&
						item.userRoleId !== userRoles.SUBCLIENT &&
						item.userRoleId !== userRoles.CHATBOT
				)
				.map((item: any) => ({
					value: item.id,
					label: `${item.firstName} ${item.lastName} - ${item.userRoleDescription}`,
				}));
			setUserOptions(users);
		}
	};

	const onUserChange = (value: number) => {
		setSelectedUser(value);
	};

	const getOrderIdFromString = async (orderId: any) => {
		try {
			const response = await api.get("Order/get-orderid-from-string", {
				params: {
					orderId: orderId,
				},
			});
			return response.data;
		} catch (error: any) {
			console.log("Error:" + error);
			toast.error("Error:" + error.message);
		}
	};
	const hexToRgba = (hex: string, alpha: number) => {
		const r = parseInt(hex.slice(1, 3), 16);
		const g = parseInt(hex.slice(3, 5), 16);
		const b = parseInt(hex.slice(5, 7), 16);
		return `rgba(${r},${g},${b},${alpha})`;
	};

	const statusColorHexCode = orderDetilsData.statusColorCode || "#ffff";
	const rgbaColor = hexToRgba(statusColorHexCode, 0.08);

	const deleteOrder = async () => {
		if (orderDetilsData.statusId > orderStatuses.REGISTERED) {
			toast.error("Kjo porosi nuk mund te fshihet nga sistemi!");
		} else {
			try {
				const response = await api.delete("Order/delete-order", {
					params: {
						orderId: await getOrderIdFromString(orderDetilsData.id),
						countryId: orderDetilsData?.countryId,
						uuid: orderDetilsData?.uuid,
					},
				});
				if (response.status === 200) {
					toast.success("Porosia u fshi me sukses");
					navigate("/order");
				}
			} catch (error: any) {
				console.log("Error:" + error);
				toast.error("Error:" + error.message);
			}
		}
	};

	const getOrDefault = (value: any, defaultValue: any) =>
		!value ? defaultValue : value;

	const [isSavingOrder, setIsSavingOrder] = useState(false);

	const saveOrderChanges = async () => {
		if (
			orderDetilsData?.transportPrice !== transportPrice &&
			(!transportPriceChangeComment ||
				transportPriceChangeComment.trim() === "")
		) {
			toast.error(
				"Ju lutem, shkruani arsyen e ndryshimit të vleres së transportit manualisht."
			);
			setOpenTransportPriceCommentModal(true);
			return;
		}

		const data = {
			orderId: await getOrderIdFromString(orderId),
			refId: refId,
			deliveryInstructions: deliveryInstructions,
			openable: openable,
			fragile: fragile,
			declared: declared,
			buyerFirstName: buyerFirstName,
			buyerLastName: buyerLastName,
			address: buyerAddress,
			addressDetails: buyerAddressDetails,
			buyerPhoneNo: buyerPhoneNo,
			orderDescription: orderDescription,
			packageDescription: packageDescription,
			weight: weight,
			length: length,
			width: width,
			height: height,
			transportPrice: transportPrice,
			orderPrice: orderPrice,
			countryId: orderDetilsData?.countryId,
			changedTransportPrice:
				orderDetilsData?.transportPrice === transportPrice
					? false
					: true,
			changedDimensions:
				orderDetilsData?.width !== parseFloat(width ?? "") ||
				orderDetilsData?.weight !== parseFloat(weight ?? "") ||
				orderDetilsData?.length !== parseFloat(length ?? "") ||
				orderDetilsData?.height !== parseFloat(height ?? "")
					? true
					: false,
			userId: orderDetilsData?.sellerId,
			changedAddress:
				orderDetilsData?.buyerAddress !== buyerAddress ? true : false,
			changedOrderPrice:
				orderDetilsData?.orderPrice !== orderPrice ? true : false,
			sectionId: sectionId,
			// Lets the API keep a new address's section inside this city if the geofence placed
			// it elsewhere. Left out when unset: the API reads JSON strictly, and "" is not a number.
			cityId: selectedCity ? Number(selectedCity) : undefined,
			sellerDescription: sellerDescription,
			uuid: orderDetilsData?.uuid,
			originCountryId: orderDetilsData?.originCountryId,
			transportPriceChangeComment: transportPriceChangeComment,
			latitude: apiLatitude,
			longitude: apiLongitude,
		};

		if (orderDetilsData?.statusId === orderStatuses.REFUNDED) {
			toast.error(
				"Kjo porosi nuk mund te ndryshohet, porosia eshte shpagim"
			);
			return;
		}
		try {
			setIsSavingOrder(true);
			const response = await api.post("Order/update-order", data);
			if (response.status === 200) {
				await getOrderDetails();
				await getOrderHistory();
				await getSettlementOrderHistory();
				toast.success("Ndryshimet u ruajten me sukses");
				return;
			}
		} catch (error: any) {
			console.log(error);
			toast.error("Error:" + error.message);
		} finally {
			setIsSavingOrder(false);
		}
	};

	const cancelChanges = () => {
		getOrderDetails();
	};

	const printTickets = async () => {
		const ids = [{ Id: orderDetilsData.displayId }];
		const params =
			selectedFormat === "A4"
				? { formatA4: true }
				: selectedFormat === "harleyTicket"
				? { harleyTicket: true }
				: {};
		try {
			const response = await api.post("Order/print-order-ticket", ids, {
				params,
				responseType: "blob",
			});
			const file = response.data;
			const fileUrl = window.URL.createObjectURL(file);

			const pdfWindow = window.open();
			if (pdfWindow) {
				pdfWindow.location.href = fileUrl;
			} else {
				toast.error(
					"Popup është i bllokuar. Ju lutemi lejoni popup-ët për këtë faqe."
				);
			}
		} catch (error) {
			console.log(error);
		}
	};

	const getZones = useCallback(async () => {
		try {
			const allZones = await fetchZonesCached();
			if (allZones) {
				setZones(allZones);
				const countries = allZones
					.filter(
						(country: Zone) =>
							country.id === orderDetilsData?.countryId
					)
					.map((country: Zone) => ({
						value: country.id,
						label: country.description,
					}));
				setCountryOptions(countries);
				const cities = allZones
					.filter(
						(city: Zone) => city.levelId === 2
						// &&
						// 	city.parentId === orderDetilsData?.countryId
					)
					.map((city: Zone) => ({
						value: city.id,
						label: city.description,
					}));
				setCityOptions(cities);
			} else {
				console.error("Failed to fetch zones.");
			}
		} catch (error) {
			console.error("An error occurred while fetching zones:", error);
		}
	}, [selectedCountry]);

	const handleCityOptionsBasedOnCountry = (countryId: any) => {
		const filteredCities = zones
			.filter((item: Zone) => item.parentId === countryId)
			.map((item: any) => ({
				value: item.id,
				label: item.description,
			}));
		setCityOptions(filteredCities);
	};

	const handleCityChange = (value: any) => {
		if (value?.value) {
			const id = value.value;
			setSelectedCity(id);
			setCityLabel(value?.label);
			setBuyerAddress("");
		} else {
			setSelectedCity("");
			setBuyerAddress("");
		}
	};

	const handleCountryChange = async (countryId: number) => {
		setSelectedCity("");
		setSelectedCountry(countryId);
		setBuyerAddress("");
		switch (countryId) {
			case 1: // Kosovo
				setCountryLabel("xk");
				break;
			case 2: // Albania
				setCountryLabel("al");
				break;
			case 3: // North Macedonia
				setCountryLabel("mk");
				break;
			default:
				break;
		}

		handleCityOptionsBasedOnCountry(countryId);
	};

	// The seller's buyers with this phone, for the existing-phone prompt. It used to download the
	// whole buyer book on every order open; the API now searches it.
	const getBuyers = async (phone: string) => {
		try {
			const response = await api.get<PagedResult<any>>(
				"Buyer/select-buyers",
				{
					params: { search: phone, pageSize: 20 },
				}
			);
			if (response.status === 200) {
				const rows = response.data.items ?? [];
				setBuyersList(rows);
				return rows;
			}
		} catch (error) {
			console.log(error);
		}
		return [];
	};
	const handleExistingPhoneNumberCancel = () => {
		const selectedBuyer = buyersList?.find(
			(item: any) => item.phone === buyerPhoneNo
		);
		setBuyerPhoneNo(initialBuyerPhoneNo);
		setIsExistingPhoneNumberVisible(false);
	};
	const handleExistingPhoneNumberOk = () => {
		const selectedBuyer = buyersList.find(
			(item: any) => item.phone === buyerPhoneNo
		);
		if (selectedBuyer) {
			setBuyerFirstName(selectedBuyer.firstName);
			setBuyerLastName(selectedBuyer.lastName);
		}
		setIsExistingPhoneNumberVisible(false);
	};

	const handlePhoneNumberBlur = async () => {
		if (!buyerPhoneNo) return;
		const selectedBuyer = (await getBuyers(buyerPhoneNo)).find(
			(item: any) => item.phone === buyerPhoneNo
		);
		if (initialBuyerPhoneNo !== buyerPhoneNo && selectedBuyer) {
			setIsExistingPhoneNumberVisible(true);
		}
	};

	const setWeightWithValidation = (value: string | null) => {
		if (value && value.includes("-")) {
			setWeight(lastValidWeight);
		} else {
			setWeight(value);
		}
	};
	const setHeightWithValidation = (value: string | null) => {
		if (value && value.includes("-")) {
			setHeight(lastValidHeight);
		} else {
			setHeight(value);
		}
	};
	const setLengthWithValidation = (value: string | null) => {
		if (value && value.includes("-")) {
			setLength(lastValidLength);
		} else {
			setLength(value);
		}
	};
	const setWidthWithValidation = (value: string | null) => {
		if (value && value.includes("-")) {
			setWidth(lastValidWidth);
		} else {
			setWidth(value);
		}
	};
	const setOrderPriceWithValidation = (value: string | null) => {
		if (value && value.includes("-")) {
			setOderPrice(lastValidOrderPrice);
		} else {
			setOderPrice(value);
		}
	};
	const setTransportPriceWithValidation = (value: string | null) => {
		if (value && value.includes("-")) {
			setTransportPrice(lastValidTransportPrice);
		} else {
			setTransportPrice(value);
		}
	};

	const [data, setData] = useState<SelectProps["options"] | any>([]);

	const handleSearch = (address: any) => {
		if (!selectedCountry || !selectedCity) {
			toast.error("Please select a country and city first");
			setBuyerAddress("");
			return;
		}

		fetchAddresesSearch(
			address +
				" ," +
				(cityLabel && cityLabel?.length > 0 ? cityLabel : "")
		);
	};

	const fetchGeoData = useCallback(async (latitude: any, longitude: any) => {
		try {
			const response = await api.get("External/get-geo-data", {
				params: {
					lng: longitude,
					lat: latitude,
					category: CONFIG?.zoneShofer ?? "",
				},
			});
			if (response.status === 200) {
				const result = response?.data;
				const section = Number(result.geofences[0]?.name);
				setSectionId(section);
			}
		} catch (error) {
			console.log(error);
		}
	}, []);

	const fetchAddresesSearch = (address: any) => {
		const params = {
			q: address || "",
			limit: "5",
			lang: "en",
		};
		const queryString = new URLSearchParams(params).toString();
		const requestOptions: RequestInit = {
			method: "GET",
			redirect: "follow",
		};

		fetch(`https://photon.komoot.io/api/?${queryString}`, requestOptions)
			.then((response) => response.json())
			.then((result) => {
				const formattedData = result.features.map((feature: any) => ({
					value: feature.properties.osm_id,
					label: feature.properties.name,
					lat: feature.geometry.coordinates[1],
					lon: feature.geometry.coordinates[0],
				}));
				setData(formattedData);
			})
			.catch((err) => console.log("err: ", err));
	};

	let autocompleteRef = useRef<any>();

	const handleChange = (address: any) => {
		const selectedLocation = address;
		if (selectedLocation) {
			const lat = selectedLocation.lat;
			const lng = selectedLocation.lng;
			setBuyerAddress(selectedLocation.label ?? "");
			setApiLatitude(lat);
			setApiLongitude(lng);
			fetchGeoData(lat, lng);
		}
	};

	const fetchSortingMachinePhotos = useCallback(async () => {
		if (!orderId) {
			return;
		}

		try {
			setIsLoadingSortingMachinePhotos(true);
			const response = await api.get<SortingMachinePhoto[]>(
				"Order/select-sorting-machine-photos",
				{
					params: { orderId },
				}
			);
			const photos = response.data ?? [];

			if (!photos.length) {
				setSortingMachinePhotos([]);
				setIsSortingMachineModalOpen(false);
				toast.info(
					strings?.sortingMachinePhotosEmpty ??
						"No sorting machine photos were found for this order."
				);
				return;
			}

			setSortingMachinePhotos(photos);
			setIsSortingMachineModalOpen(true);
		} catch (error) {
			console.log(error);
		} finally {
			setIsLoadingSortingMachinePhotos(false);
		}
	}, [orderId, strings]);

	useEffect(() => {
		const handleKeyDown = (event: KeyboardEvent) => {
			if (
				(event.key === "Enter" || event.code === "NumpadEnter") &&
				!isSavingOrder
			) {
				saveOrderChanges();
			}
		};

		window.addEventListener("keydown", handleKeyDown);

		return () => {
			window.removeEventListener("keydown", handleKeyDown);
		};
	}, [isSavingOrder, saveOrderChanges]);

	const cancleTransportModal = () => {
		setTransportPriceChangeComment("");
		setOpenTransportPriceCommentModal(false);
	};

	const handleTransportPriceCommentOk = () => {
		if (
			!transportPriceChangeComment ||
			transportPriceChangeComment.trim() === ""
		) {
			toast.error(
				"Ju lutem, shkruani arsyen e ndryshimit të çmimit të transportit."
			);
			return;
		}

		saveOrderChanges();
		setOpenTransportPriceCommentModal(false);
		setTransportPriceChangeComment("");
	};

	return (
		<>
			<div className="detailContainer">
				<OrderPriceChangeRequest
					orderId={orderId}
					onButtonsPress={async () => {
						await getOrderDetails();
					}}
				/>

				<div className="firstDetail">
					<div className="titleButton">
						<div className="flex flex-row items-center gap-2">
							<h1 className="font-bold text-[18px]">{`${strings?.title} #${orderDetilsData.displayId}`}</h1>
							{hasAccess("SORTING_MACHINE_PHOTOS_ACCESS") && (
								<Button
									size="large"
									icon={<CameraOutlined />}
									style={{
										color: "#4F16C2",
									}}
									loading={isLoadingSortingMachinePhotos}
									onClick={fetchSortingMachinePhotos}
								>
									{strings?.sortingMachinePhotosButton}
								</Button>
							)}
						</div>
						<div className="flex flex-row flex-wrap justify-center gap-4 ">
							{(canChangeOrderStatus ||
								canReopenReturnedOrderToStorage) &&
							(orderDetilsData?.completed === 0 ||
								orderDetilsData?.settlementStatus === 0) &&
							orderDetilsData?.isInRefund === false &&
							orderDetilsData?.hasDriverSettlement === false &&
							(canReopenReturnedOrderToStorage ||
								orderDetilsData.statusId !==
									orderStatuses.RETURNED) ? (
								<div>
									<Button
										size="large"
										style={{ color: "#4f16c2" }}
										icon={<FormOutlined />}
										onClick={openStatusChangeWindow}
									>
										{strings?.adminButton}
									</Button>
								</div>
							) : orderDetilsData?.statusId ===
									orderStatuses.REGISTERED &&
							  orderDetilsData?.isInRefund === false &&
							  isClient ? (
								<div>
									<Button
										size="large"
										type="primary"
										danger
										icon={<FormOutlined />}
										onClick={() => setOpen(true)}
									>
										{strings?.readyForPickupButton}
									</Button>
								</div>
							) : orderDetilsData?.statusId ===
									orderStatuses.WAITING_PICKUP &&
							  orderDetilsData?.isInRefund === false &&
							  isClient ? (
								<div>
									<Button
										size="large"
										// type="primary"
										// danger
										style={{ color: "#4f16c2" }}
										icon={<FormOutlined />}
										onClick={() =>
											setOpenChangeStatusToPreviousModal(
												true
											)
										}
									>
										{strings?.removewaitingpickup}
									</Button>
								</div>
							) : null}
							{warehouseManager &&
							orderDetilsData?.isInRefund === false &&
							orderDetilsData.statusId !==
								orderStatuses.RETURNED ? (
								<div>
									<Button
										size="large"
										// type="primary"
										// danger
										style={{ color: "#4f16c2" }}
										icon={<FormOutlined />}
										onClick={openStatusChangeWindow}
									>
										{strings?.warehouseManagerButton}
									</Button>
								</div>
							) : null}

							<Button
								size="large"
								style={{
									backgroundColor: "#4F16C2",
									color: "#ffff",
								}}
								icon={<PrinterOutlined />}
								onClick={() => setIsPrintModalOpen(true)}
							>
								{strings?.printTicketButton}
							</Button>
							{orderDetilsData.statusId ===
								orderStatuses.REGISTERED &&
								orderDetilsData?.statusId !==
									orderStatuses.REFUNDED && (
									<Button
										size="large"
										// type="primary"
										style={{
											backgroundColor: "#ffff",
											color: "#FF3B30",
										}}
										// danger
										icon={<DeleteOutlined />}
										onClick={deleteOrder}
									>
										{strings?.deleteOrderButton}
									</Button>
								)}
						</div>
					</div>
				</div>
				{/*
				 * Correcting the currency the order was REGISTERED in.
				 *
				 * Its own panel, outside the details rows, because it is its own endpoint and its
				 * own permission — the details rows all save together through update-order, this
				 * one saves alone and re-prices the order as it goes.
				 *
				 * Three gates, all of which must hold:
				 *   · dualCurrencyEnabled — PostmanAL only. Kosovo and Macedonia have one currency,
				 *     so there is nothing to correct and nothing to render.
				 *   · ORDER_CURRENCY_CHANGE_ACCESS — staff only. The API refuses Client and
				 *     SubClient by role as well, so this is the convenience half of the gate, not
				 *     the security half.
				 *   · the order is still changeable — see orderCurrencyLocked. Shown disabled
				 *     rather than hidden once it is not, so the currency is still legible and the
				 *     reason it cannot be changed is on screen.
				 */}
				{dualCurrencyEnabled && canChangeOrderCurrency && (
					<div className="orderCurrencyPanel">
						<CurrencySelectField
							label={
								strings?.orderCurrency?.label ??
								"Monedha e porosisë"
							}
							currencies={selectableCurrencies}
							value={editedOrderCurrencyId}
							onChange={setEditedOrderCurrencyId}
							disabled={
								orderCurrencyLocked || savingOrderCurrency
							}
						/>
						{/* Contrast fix + confirmation: see orderCurrencySaveButtonStyle. */}
						<Button
							size="large"
							type="primary"
							className="orderCurrencySaveButton"
							style={orderCurrencySaveButtonStyle}
							loading={savingOrderCurrency}
							disabled={orderCurrencySaveDisabled}
							onClick={() => setOrderCurrencyConfirmOpen(true)}
						>
							{strings?.orderCurrency?.saveButton ??
								"Ruaj monedhën"}
						</Button>
						<span className="orderCurrencyNote">
							{orderCurrencyInternational
								? strings?.orderCurrency?.internationalNote ??
								  "Porosia është ndërkombëtare — monedha e regjistrimit nuk mund të ndryshohet."
								: orderCurrencyLocked
								? strings?.orderCurrency?.lockedNote ??
								  "Porosia është dorëzuar — monedha nuk mund të ndryshohet."
								: // A NEW key, not an edit of `hint`. The old string ends
								  // "Vlera e porosisë nuk konvertohet" — the exact opposite of what
								  // the endpoint now does — and a `??` fallback cannot rescue a key
								  // that exists with stale text.
								  strings?.orderCurrency?.hintConverts ??
								  "Ndryshimi konverton vlerën e porosisë me kursin e ruajtur në porosi dhe rillogarit çmimin e transportit sipas tarifave të monedhës së re."}
						</span>
					</div>
				)}
				{/*
				 * The confirmation.
				 *
				 * It exists because the button changed meaning: it used to correct a label, and now
				 * it re-prices the order — what the seller is owed and what the buyer hands over.
				 *
				 * It states what will happen and deliberately does NOT predict the number. The
				 * conversion runs at the rate frozen on the order, which this screen does not have;
				 * `useCurrencies().convert` knows only the live mid rate, so any preview drawn here
				 * would differ from the figure about to be written. The toast and the refetch report
				 * the real one a moment later.
				 */}
				<Modal
					open={orderCurrencyConfirmOpen}
					title={
						strings?.orderCurrency?.confirmTitle ??
						"Konfirmo ndryshimin e monedhës"
					}
					onCancel={() => setOrderCurrencyConfirmOpen(false)}
					onOk={saveOrderCurrency}
					confirmLoading={savingOrderCurrency}
					okButtonProps={{
						className: "orderCurrencySaveButton",
						style: orderCurrencySaveButtonStyle,
						disabled: orderCurrencySaveDisabled,
					}}
					okText={strings?.orderCurrency?.confirmOk ?? "Po, ndrysho"}
					cancelText={strings?.buttons?.cancel ?? "Anulo"}
				>
					<p>
						{strings?.orderCurrency?.confirmBody ??
							"Vlera e porosisë do të konvertohet në monedhën e re me kursin e ruajtur në porosi, dhe çmimi i transportit do të rillogaritet sipas tarifave të asaj monedhe."}
					</p>
					<p className="orderCurrencyNote">
						{strings?.orderCurrency?.confirmSpreadNote ??
							"Kthimi në monedhën e mëparshme nuk e rikthen shumën fillestare: konvertimi bëhet me kursin e blerjes dhe të shitjes."}
					</p>
				</Modal>
				{/*
				 * Correcting the currency the driver actually COLLECTED.
				 *
				 * The mirror of the panel above and gated the same way, except that its window is
				 * the opposite one: this opens at delivery and closes when the driver is settled.
				 * In practice exactly one of the two is ever enabled on a given order.
				 *
				 * Shown disabled rather than hidden, so the collected currency stays legible and
				 * the note says which edge of the window the order is on - "not delivered yet" and
				 * "driver already settled" are very different answers, and hiding the panel would
				 * leave staff unable to tell either from "I lack the permission".
				 */}
				{dualCurrencyEnabled && canChangeDeliveredCurrency && (
					<div className="deliveredCurrencyPanel">
						<CurrencySelectField
							label={
								strings?.deliveredCurrency?.label ??
								"Monedha e arkëtimit"
							}
							currencies={selectableCurrencies}
							value={editedDeliveredCurrencyId}
							onChange={setEditedDeliveredCurrencyId}
							disabled={
								deliveredCurrencyLocked ||
								savingDeliveredCurrency
							}
						/>
						<Button
							size="large"
							type="primary"
							className="orderCurrencySaveButton"
							style={deliveredCurrencySaveButtonStyle}
							loading={savingDeliveredCurrency}
							disabled={deliveredCurrencySaveDisabled}
							onClick={saveDeliveredCurrency}
						>
							{strings?.deliveredCurrency?.saveButton ??
								"Ruaj monedhën e arkëtimit"}
						</Button>
						<span className="deliveredCurrencyNote">
							{deliveredCurrencyNotDelivered
								? strings?.deliveredCurrency
										?.notDeliveredNote ??
								  "Porosia nuk është dorëzuar ende — monedha e arkëtimit caktohet në dorëzim."
								: deliveredCurrencyLocked
								? strings?.deliveredCurrency?.settledNote ??
								  "Shoferi është barazuar tashmë — monedha e arkëtimit nuk mund të ndryshohet."
								: strings?.deliveredCurrency?.hint ??
								  "Monedha që shoferi ka arkëtuar realisht. Ndryshimi nuk prek vlerën e porosisë as barazimin e klientit."}
						</span>
					</div>
				)}
				<div className="secondDetail">
					<div className="orderDetail">
						<OrderDetailRow
							label={strings?.orderDetails?.title}
							value={""}
							classNameLabel="!text-[#4F16C2] !uppercase"
						/>
						{(orderDetilsData?.completed === 1 ||
							orderDetilsData?.settlementStatus > 0) && (
							<Alert
								message={"Porosia është mbyllur"}
								description={
									"Kjo porosi eshte barazuar me klientin  dhe" +
									" eshte mbyllur per ndryshime ne sistem! "
								}
								type="success"
								showIcon
								style={{
									color: "red",
									// borderColor: " white",
									marginBottom: "8px",
								}}
							/>
						)}
						{orderDetilsData?.isInRefund && (
							<Alert
								message={"Porosia është e perfshire ne shpagim"}
								description={
									"Kjo porosi eshte e perfshire ne shpagim dhe " +
									" eshte mbyllur per ndryshime ne sistem! "
								}
								type="warning"
								showIcon
								style={{
									color: "red",
									// borderColor: " white",
									marginBottom: "8px",
								}}
							/>
						)}
						{orderDetilsData?.hasDriverSettlement && (
							<Alert
								message={"Porosia është e barazuar nga shoferi"}
								description={
									"Kjo porosi eshte e barazuar nga shoferi dhe " +
									" eshte mbyllur per ndryshime te statusit ne sistem! "
								}
								type="warning"
								showIcon
								style={{
									color: "red",
									// borderColor: " white",
									marginBottom: "8px",
								}}
							/>
						)}
						<OrderDetailRow
							label={strings?.orderDetails.code}
							value={"#" + orderDetilsData.displayId}
							style={style.oddRow}
						/>
						{orderDetilsData?.createdByUsername && (
							<OrderDetailRow
								label="Krijuar nga useri"
								value={orderDetilsData.createdByUsername}
							/>
						)}
						<OrderDetailRow
							label={strings?.orderDetails.refId}
							value={refId}
							inputStyle={style.inputStyle}
							onChangeText={setRefId}
							editable={allowEdit}
						/>
						{requiresDeliveryCode && hasAccessToDeliveryCode && (
							<OrderDetailRow
								label={strings?.orderDetails.deliveryCode}
								value={deliveryCode}
								inputStyle={style.inputStyle}
							/>
						)}
						{hasAccessToIdentificationNo && (
							<OrderDetailRow
								label={
									strings?.orderDetails.identificationNumber
								}
								value={
									orderDetilsData?.buyerIdentificationNumber
								}
								style={style.oddRow}
							/>
						)}
						{!isClient && hasAccessToSellers && (
							<>
								<OrderDetailRow
									label="Shitesi"
									value={
										orderDetilsData?.sellerNameAndSurname
									}
									style={style.oddRow}
								/>
								<OrderDetailRow
									label="Numri i shitesit "
									value={orderDetilsData?.sellerPhoneNo}
								/>
							</>
						)}
						<OrderDetailRow
							label={strings?.orderDetails.status}
							value={
								<div className="statusStyle">
									<div
										className="statusValues"
										style={{
											background: rgbaColor,
											color: statusColorHexCode,
										}}
									>
										<p className="text-lg">&#x2022;</p>
										<p className="w-full">
											{orderDetilsData.status}
										</p>
									</div>
								</div>
							}
							inputStyle={style.inputStyle}
							style={style.oddRow}
						/>
						<OrderDetailRow
							label={strings?.orderDetails.buyer.firstName}
							value={buyerFirstName}
							editable={allowEdit}
							onChangeText={setBuyerFirstName}
							inputStyle={style.inputStyle}
						/>
						<OrderDetailRow
							label={strings?.orderDetails.buyer.lastName}
							value={buyerLastName}
							editable={allowEdit}
							onChangeText={setBuyerLastName}
							inputStyle={style.inputStyle}
						/>
						<OrderDetailRow
							label={strings?.orderDetails.buyer.country}
							editable={false}
							options={countryOptions}
							value={orderDetilsData?.country}
							style={style.oddRow}
						/>
						<OrderDetailRow
							label={strings?.orderDetails.buyer.city}
							editable={allowEdit}
							select={true}
							options={cityOptions}
							value={
								allowEdit ? selectedCity : orderDetilsData?.city
							}
							onChange={handleCityChange}
							labelInValue={true}
						/>
						{/* <OrderDetailRow
							label={strings?.orderDetails.buyer.address}
							value={buyerAddress}
							editable={allowEdit}
							onChangeText={setBuyerAddress}
							style={style.oddRow}
							inputStyle={{ width: "300px" }}
						/> */}
						<div
							className="flex flex-row  items-center min-h-14 p-3"
							style={{
								...style.oddRow,
								display: !allowEdit ? "none" : "flex",
							}}
						>
							<p style={style.label}>
								{strings?.orderDetails.buyer.address}:
							</p>
							{/* <PlaceAutocomplete
								onAddressChange={handleChange}
								country={countryLabel}
								ref={autocompleteRef}
							/> */}
							<AddressSelect
								onAddressChange={handleChange}
								country={countryLabel}
								selectedAddress={buyerAddress}
								city={selectedCity}
							/>
						</div>
						{!allowEdit && (
							<OrderDetailRow
								label={strings?.orderDetails.buyer.address}
								value={buyerAddress}
								options={data}
								style={style.oddRow}
								inputStyle={style.inputStyle}
							/>
						)}
						<OrderDetailRow
							label={strings?.orderDetails.buyer.addressDetails}
							value={buyerAddressDetails}
							editable={allowEdit}
							onChangeText={setBuyerAddressDetails}
							style={style.oddRow}
							inputStyle={style.inputStyle}
						/>
						<OrderDetailRow
							label={strings?.orderDetails.buyer.phone}
							value={buyerPhoneNo}
							editable={allowEdit}
							onChangeText={setBuyerPhoneNo}
							inputStyle={style.inputStyle}
						/>
						<OrderDetailRow
							label={strings?.orderDetails.description}
							value={orderDescription}
							style={style.oddRow}
							editable={allowEdit}
							onChangeText={setOrderDescription}
							inputStyle={style.inputStyle}
						/>
						<OrderDetailRow
							label={strings?.orderDetails.packageDescription}
							value={packageDescription}
							editable={allowEdit}
							onChangeText={setPackageDescription}
							inputStyle={style.inputStyle}
						/>
						<OrderDetailRow
							label={strings?.orderDetails.deliveryInstructions}
							value={deliveryInstructions}
							style={style.oddRow}
							editable={allowEdit}
							onChangeText={setDeliveryInstructions}
							inputStyle={style.inputStyle}
						/>
						{allowEditSellerDescription &&
							!isClient &&
							orderDetilsData?.originCountryId !==
								orderDetilsData?.countryId &&
							accessToOrderRealSeller && (
								<OrderDetailRow
									label={
										strings?.orderDetails.sellerDescription
									}
									value={sellerDescription}
									editable={allowEditSellerDescription}
									onChangeText={setSellerDescription}
								/>
							)}
						{accessToOrderDimensions && (
							<OrderDetailRow
								label={strings?.orderDetails.weight}
								value={weight}
								editable={allowEdit && !isClient}
								onChangeText={setWeightWithValidation}
								type="number"
							/>
						)}
						{allowEdit && !isClient && canUpdateOrderDimensions ? (
							<>
								<OrderDetailRow
									label={
										strings?.orderDetails.dimensions.length
									}
									value={length}
									style={style.oddRow}
									editable={allowEdit}
									onChangeText={setLengthWithValidation}
									type="number"
								/>
								<OrderDetailRow
									label={
										strings?.orderDetails.dimensions.width
									}
									value={width}
									editable={allowEdit}
									onChangeText={setWidthWithValidation}
									type="number"
								/>
								<OrderDetailRow
									label={
										strings?.orderDetails.dimensions.height
									}
									value={height}
									style={style.oddRow}
									editable={allowEdit}
									onChangeText={setHeightWithValidation}
									type="number"
								/>
							</>
						) : accessToOrderDimensions ? (
							<OrderDetailRow
								label="Dimensionet(~cm)"
								value={orderDetilsData.dimensions}
								style={style.oddRow}
							/>
						) : (
							<></>
						)}
						<OrderDetailRow
							label={
								strings?.orderDetails.orderPrice +
								currencySymbol(orderDetilsData?.currencyId)
							}
							value={orderPrice}
							onChangeText={setOrderPriceWithValidation}
							editable={
								(allowOrderPriceEditing && isClient) ||
								(allowEdit &&
									!orderDetilsData?.returnable &&
									!isClient &&
									canChangeOrderValue)
							}
						/>
						{accessToOrderRealPrice && (
							<OrderDetailRow
								label={
									strings?.orderDetails.ordersRealPrice +
									currencySymbol(orderDetilsData?.currencyId)
								}
								value={orderDetilsData?.ordersRealPrice}
								style={style.oddRow}
							/>
						)}
						{accessToOrderTransportPrice && (
							<OrderDetailRow
								label={
									strings?.orderDetails.transportPrice +
									currencySymbol(orderDetilsData?.currencyId)
								}
								value={transportPrice}
								onChangeText={setTransportPriceWithValidation}
								editable={
									allowEditTransportPrice &&
									!isClient &&
									canChangeOrderValue
								}
							/>
						)}
						{accessToSaleProfit && (
							<OrderDetailRow
								label={
									strings?.orderDetails.saleProfit +
									currencySymbol(orderDetilsData?.currencyId)
								}
								value={` ${orderDetilsData.saleProfit}`}
								style={style.oddRow}
							/>
						)}
						<OrderDetailRow
							label={strings?.orderDetails.exchangeable}
							value={orderDetilsData.exchangeableString?.toString()}
						/>
						<OrderDetailRow
							label={strings?.orderDetails.invoice}
							value={orderDetilsData.invoiceString?.toString()}
							style={style.oddRow}
						/>
						<OrderDetailRow
							label={strings?.orderDetails.openable}
							value={orderDetilsData.openableString?.toString()}
							style={style.oddRow}
							bool={true}
							editable={allowEdit}
							checked={openable}
							onCheck={setOpenable}
						/>
						<OrderDetailRow
							label={strings?.orderDetails.fragile}
							value={orderDetilsData.fragileString?.toString()}
							bool={allowEdit}
							editable={allowEdit}
							checked={fragile}
							onCheck={setFragile}
						/>
						<OrderDetailRow
							label={strings?.orderDetails.declared}
							value={orderDetilsData.declaredString?.toString()}
							style={style.oddRow}
							bool={allowEdit}
							editable={allowEdit}
							checked={declared}
							onCheck={setDeclared}
						/>
					</div>
					<div className="orderHistory">
						<div className="pb-4">
							<OrderDetailRow
								label={strings?.orderHistory}
								value={""}
								classNameLabel="!text-[#4F16C2] !uppercase"
							/>
						</div>
						<div className="orderHistoryLines">
							{orderHistory && orderHistory.length > 0 ? (
								orderHistory.map((item, index) => (
									<OrderHistory
										key={index}
										date={item?.statusDate}
										statusChangeComment={
											item?.statusChangeComment ?? " - "
										}
										userName={item?.userName ?? " - "}
										phone={item?.phone ?? " - "}
										statusId={item?.statusId ?? 0}
									/>
								))
							) : (
								<></>
							)}
							{/* {settlementOrderHistory && (
								<> */}
							{accessToSettlementHistory && (
								<>
									{settlementOrderHistory?.map(
										(item, index) => (
											<SettlementOrderHistory
												key={index}
												date={item?.statusDate}
												statusChangeComment={
													item?.statusChangeComment ??
													" - "
												}
												userName={
													item?.userName ?? " - "
												}
												phone={item?.phone ?? " - "}
												statusId={item?.statusId ?? 0}
											/>
										)
									)}
								</>
							)}
							{/* </>
							)} */}
						</div>
					</div>
				</div>
				<div className="buttonat">
					<Buttons
						button1Text={strings?.buttons.cancel}
						onButton1Click={cancelChanges}
						button2Text={strings?.buttons.saveChanges}
						onButton2Click={saveOrderChanges}
						disabled={
							isSavingOrder ||
							(openTransportPriceCommentModal &&
								!transportPriceChangeComment?.trim())
						}
					/>
				</div>
			</div>

			<Modal
				open={openStatusChangeModal}
				title={strings?.modals?.changeStatus?.title}
				onCancel={() => setOpenStatusChangeModal(false)}
				width={1500}
				footer={(_, { OkBtn, CancelBtn }) => (
					<div className="flex items-end justify-end"></div>
				)}
			>
				<Divider />
				<div className="flex flex-row justify-between">
					<div className="w-1/3">
						<p style={style.modalUnderTitles}>
							{strings?.modals.changeStatus.selectedOrders}
						</p>
						<Divider />
						<p style={style.selectedOrder}>
							#{orderDetilsData.displayId}
						</p>
					</div>
					<div className="w-1/3">
						<p style={style.modalUnderTitles}>
							{strings?.modals.changeStatus.setChanges}
						</p>
						<Divider />
						<div className="bg-slate-200 flex flex-col gap-4 p-6">
							<DefaultSelect
								placeholder="- Zgjedhe statusin"
								// width={320}
								options={translatedStatusOptions}
								onChange={onStatusChange}
								value={selectedStatus}
								className="input"
							/>
							<DefaultSelect
								// width={320}
								placeholder="- Zgjedhe pergjegjesin"
								options={userOptions}
								onChange={onUserChange}
								value={selectedUser}
								className="input"
							/>
							<Alert
								type="warning"
								showIcon
								message={"Verejtje"}
								description={
									"Ju lutem qe te keni kujdes gjate perdorimit te ketij moduli." +
									" Ndryshimet do te evidentohen tek te gjitha porosite e zgjedura. "
								}
								style={{
									backgroundColor: "white",
									borderColor: " white",
								}}
							/>
							<Button
								size="large"
								danger
								className="bg-red-100"
								onClick={orderStatusChange}
								icon={<CheckOutlined />}
								style={{
									fontSize: 18,
									fontWeight: 600,
								}}
								disabled={
									isUpdatingStatus || onStatusChangeDisabled
								}
							>
								{strings?.modals?.changeStatus?.saveChanges}
							</Button>
						</div>
					</div>
					<div className="w-1/3 ">
						<p style={style.modalUnderTitles}>
							{strings?.modals?.changeStatus?.info?.title}
						</p>
						<Divider />

						<div className="pl-8">
							<ol
								style={{
									listStyle: "decimal",
									fontSize: 16,
									color: "#1B4965",
								}}
							>
								<li>
									{
										strings?.modals?.changeStatus?.info
											?.items[0]
									}
								</li>
								<li>
									{
										strings?.modals?.changeStatus?.info
											?.items[1]
									}
									<ul
										style={{
											listStyle: "circle",
											paddingLeft: 30,
										}}
									>
										{strings?.modals?.changeStatus?.info?.subItems?.transport.map(
											(subItem: any, index: number) => (
												<li key={index}>{subItem}</li>
											)
										)}
									</ul>
								</li>
								<li>
									{
										strings?.modals?.changeStatus?.info
											?.items[2]
									}
									<ul
										style={{
											listStyle: "circle",
											paddingLeft: 30,
										}}
									>
										{strings?.modals?.changeStatus?.info?.subItems?.warehouse?.map(
											(subItem: any, index: number) => (
												<li key={index}>{subItem}</li>
											)
										)}
									</ul>
								</li>
							</ol>
						</div>
					</div>
				</div>
			</Modal>
			<Modal
				open={open}
				onCancel={() => setOpen(false)}
				onOk={orderStatusChange}
				title={strings?.modals.confirm.title}
				okButtonProps={{
					className: "bg-blue-500",
					disabled: isUpdatingStatus,
				}}
			>
				<p>{strings?.modals.confirm.message}</p>
			</Modal>
			<Modal
				open={openChangeStatusToPreviousModal}
				onCancel={() => setOpenChangeStatusToPreviousModal(false)}
				onOk={orderStatusChangeToPreviousStatus}
				title={strings?.modals.confirm.title}
				okButtonProps={{ className: "bg-blue-500" }}
			>
				<p>{strings?.modals.confirm.registerModalMessage}</p>
			</Modal>
			<Modal
				title={strings?.existingPhoneNumberChangeTitle}
				open={isExistingPhoneNumberVisible}
				onCancel={handleExistingPhoneNumberCancel}
				onOk={handleExistingPhoneNumberOk}
				okButtonProps={{ className: "bg-blue-500" }}
				cancelText={strings?.buttons.cancel}
				okText={strings?.okButtonText}
			>
				<p>{strings?.existingPhoneNumberChangeMessage}</p>
			</Modal>
			<Modal
				title="Zgjidh Formatin e Printimit"
				open={isPrintModalOpen}
				onOk={() => {
					setIsPrintModalOpen(false);
					printTickets();
				}}
				onCancel={() => setIsPrintModalOpen(false)}
				footer={
					<Buttons
						button1Text="Anulo"
						button2Text="Printo"
						onButton1Click={() => setIsPrintModalOpen(false)}
						onButton2Click={printTickets}
					/>
				}
			>
				<Radio.Group
					value={selectedFormat}
					onChange={(e) => setSelectedFormat(e.target.value)}
				>
					<Radio value="100x60">100x60</Radio>

					{hasAccessToA4 && <Radio value="A4">A4</Radio>}
					{hasAccessToHarleyTickets && (
						<Radio value="harleyTicket">Harley tiket</Radio>
					)}
				</Radio.Group>
			</Modal>
			<Modal
				title={"Sheno arsyen e ndryshimit te vleres se Transportit"}
				open={openTransportPriceCommentModal}
				onCancel={cancleTransportModal}
				onOk={handleTransportPriceCommentOk}
				okButtonProps={{ className: "bg-blue-500" }}
				cancelText={strings?.buttons.cancel}
				okText={strings?.okButtonText}
			>
				<DefaultInput
					placeholder={"Shenim"}
					value={transportPriceChangeComment}
					onChange={(e) =>
						setTransportPriceChangeComment(e.target.value)
					}
					allowClear
					// label={""}
					className={style.commentInputStyle}
				/>
			</Modal>

			<Modal
				open={isSortingMachineModalOpen}
				title={strings?.sortingMachinePhotosModalTitle}
				onCancel={() => setIsSortingMachineModalOpen(false)}
				footer={null}
				width={900}
			>
				<div className="grid gap-6 md:grid-cols-2">
					{sortingMachinePhotos.map((photo) => {
						const sizeInKb =
							typeof photo.sizeBytes === "number"
								? (photo.sizeBytes / 1024).toFixed(2)
								: null;

						return (
							<div
								key={photo.objectKey}
								className="flex flex-col gap-2"
							>
								<img
									src={`data:image/png;base64,${photo.base64Data}`}
									alt={`sorting-machine-${photo.objectKey}`}
									className="max-h-96 w-full rounded bg-slate-100 object-contain"
								/>
								<div className="text-sm text-gray-600">
									<p>{photo.objectKey}</p>
									<p>
										Camera ID: {photo.cameraId} · Size:{" "}
										{sizeInKb ? `${sizeInKb} KB` : "-"}
									</p>
								</div>
							</div>
						);
					})}
				</div>
			</Modal>
		</>
	);
};

export default OrderDetails;
const style = {
	oddRow: { backgroundColor: "#f7f8fa" },
	modalUnderTitles: {
		fontSize: 18,
		color: "#1B4965",
	},
	//fix width
	selectedOrder: {
		backgroundColor: "#5FA8D3",
		fontSize: 18,
		color: "white",
		width: "fit-content",
		borderRadius: 4,
	},
	inputStyle: {
		width: "100%",
	},
	commentInputStyle: {
		width: "100%",
	},
	container: {
		// backgroundColor: "#fff",
		// padding: 8,
		// paddingLeft: 6,
		// borderBottom: "1px solid #eee",
		// gap: "16px",
		height: "40px",
		width: "8.8rem",
	},
	label: {
		fontSize: 14,
		fontWeight: "bold",
		color: "#2C2C2C",
		fontFamily: "Inter",
		width: "50%",
	},
	value: {
		width: "50%",
		fontFamily: "Inter",
		color: "#2C2C2C",
		fontSize: 14,
		fontWeight: 400,
		display: "flex",
		justifyContent: "flex-start",
	},
	editableContainer: {
		width: "50%",
		display: "flex",
		justifyContent: "flex-start",
	},
	textInput: {
		backgroundColor: "#fff",
		height: "40px",
		width: "10rem",
	},
	textContainer: {
		outline: "none",
		width: "9rem",
	},
	switch: {
		width: "50%",
		display: "flex",
		justifyContent: "flex-start",
	},
};
